import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const MiniClose24 = (props: SvgIconProps): JSX.Element => React.createElement(
    SvgIcon,
    props,
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
        <path fillRule='evenodd' clipRule='evenodd' d='M16.5855 18C16.9761 18.3905 17.6092 18.3905 17.9998 18C18.3903 17.6095 18.3903 16.9763 17.9998 16.5858L13.4139 11.9999L17.9996 7.41421C18.3902 7.02368 18.3902 6.39052 17.9996 5.99999C17.6091 5.60946 16.9759 5.60946 16.5854 5.99999L11.9997 10.5857L7.41415 5.99993C7.02362 5.6094 6.39045 5.6094 5.99993 5.99993C5.6094 6.39045 5.6094 7.02362 5.99993 7.41415L10.5854 11.9999L5.99992 16.5858C5.6094 16.9763 5.6094 17.6095 5.99992 18C6.39045 18.3905 7.02362 18.3905 7.41415 18L11.9997 13.4141L16.5855 18Z' />
    </svg>,
);
